import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * GET /api/notifications - Get notifications for authenticated user
 */

// Query parameter schema
export const GetNotificationsQuerySchema = z.object({
  type: z.enum(['chat', 'sale', 'purchase', 'transaction', 'system']).optional(),
  isRead: z.enum(['true', 'false']).optional(),
  limit: z.string().optional().default('20'),
  offset: z.string().optional().default('0'),
});

export type GetNotificationsQuery = z.infer<typeof GetNotificationsQuerySchema>;

// Notification schema for response
// Using z.coerce.date() to handle ISO string dates from JSON
export const NotificationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  type: z.enum(['chat', 'sale', 'purchase', 'transaction', 'system']),
  title: z.string(),
  message: z.string(),
  actionUrl: z.string().nullable(),
  metadata: z.any(),
  isRead: z.boolean(),
  createdDate: z.coerce.date(),
  readDate: z.coerce.date().nullable(),
});

export type Notification = z.infer<typeof NotificationSchema>;

// GET response schema - using discriminatedUnion
export const GetNotificationsResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    notifications: z.array(NotificationSchema),
    total: z.number(),
    hasMore: z.boolean(),
    page: z.number(),
  }),
  ErrorResponseSchema,
]);

export type GetNotificationsResponse = z.infer<typeof GetNotificationsResponseSchema>;
